/* eslint-disable import/no-cycle */
import React from 'react';
import { WrappedFunctionProps } from '../types';
import { NumberField as FormNumberField } from '../../apiForm/form/input';

export default function IntegerField({
  inputKey,
  translation,
  language,
  control,
}: WrappedFunctionProps) {
  return (
    <FormNumberField
      control={control}
      name={inputKey}
      label={translation?.title?.[language] || inputKey}
      helperText={translation?.description?.[language]}
      integer
    />
  );
}
